import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import TestForm from "../components/tests/TestForm";
import TestEditorErrorBoundary from "../components/tests/TestEditorErrorBoundary";
import { getTestEditorDraft } from "../services/testApi";
import { useAlertContext } from "../context/AlertContext";

export default function TestEditorPage() {
    const { testId } = useParams();
    const navigate = useNavigate();
    const { showAlert } = useAlertContext();
    const [test, setTest] = useState(null);
    const [loading, setLoading] = useState(Boolean(testId));
    const editing = Boolean(testId);

    useEffect(() => {
        if (!editing) return;
        let active = true;
        getTestEditorDraft(testId)
            .then((value) => {
                if (!active) return;
                if (!value) throw new Error("Тест не найден");
                setTest({
                    ...value.state?.formData,
                    id: value.id,
                    questions: value.state?.questions || [],
                    publication_status: value.publication_status,
                    published_version: value.published_version,
                    has_unpublished_changes: value.has_unpublished_changes,
                    updated_at: value.updated_at,
                });
            })
            .catch((error) => {
                showAlert(`Не удалось загрузить тест: ${error.message || error}`, "error");
                navigate("/tests", { replace: true });
            })
            .finally(() => active && setLoading(false));
        return () => { active = false; };
    }, [editing, navigate, showAlert, testId]);

    if (loading) {
        return <MainLayout><div className="py-20 text-center text-slate-500">Загружаем тест…</div></MainLayout>;
    }

    return (
        <MainLayout className="h-full overflow-y-auto bg-slate-50/70">
            <div className="w-full pb-16">
                <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
                    <div>
                        <Link to="/tests" className="mb-3 inline-flex items-center gap-2 text-sm font-medium text-slate-500 hover:text-slate-900">
                            <span aria-hidden="true">←</span> К библиотеке тестов
                        </Link>
                        <h1 className="text-3xl font-bold tracking-tight text-slate-950">
                            {editing ? "Редактирование теста" : "Новый тест"}
                        </h1>
                        <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-500">
                            Настройте правила прохождения и подготовьте вопросы. Черновик сохраняется в этом браузере автоматически.
                        </p>
                    </div>
                </div>

                <TestEditorErrorBoundary testId={test?.id}>
                    <TestForm
                        key={test?.id || "new"}
                        initialData={test}
                        onClose={() => navigate("/tests")}
                        onTestAdded={() => navigate("/tests")}
                        onDraftCreated={(id) => window.history.replaceState(null, "", `/tests/${id}/edit`)}
                        allowAi={!editing || !test?.published_version}
                        pageMode
                    />
                </TestEditorErrorBoundary>
            </div>
        </MainLayout>
    );
}
